import React from 'react';

import {Link} from '../../../../lib/routes';

type Props = {
	args: string[];
};

// {@book PaBTSO, Фандельвер и его глубины}
export const BookPlugin: React.FC<Props> = ({args}) => {
	const [bookId, ...rest] = args;
	const title = rest.join(', ') || bookId;

	return (
		<Link route={'book'} params={{bookId}} title={title}>
			{title}
		</Link>
	);
};
